import { TBrandsList } from 'entities/Brand';
import { commonApi } from 'shared/api/commonApi';
import { EApiTags } from 'shared/typings';
import { getCookie } from 'shared/utils/getCookie';

export const brandsApi = commonApi
	.injectEndpoints({
		endpoints: (builder) => ({
			getBrandsList: builder.query<TBrandsList, string>({
				query: (params) => ({
					url: `brands/${params ? '?' : ''}${params}`,
				}),
			}),

			joinBrands: builder.mutation<null, { uuid: string; body: string[] }>({
				query({ uuid, body }) {
					return {
						url: `brands/${uuid}/join/`,
						headers: { 'X-Csrftoken': getCookie('csrftoken') },
						method: 'POST',
						body: {
							sources_uuids: body,
						},
					};
				},
			}),

			joinOffer: builder.mutation<null, { uuid: string; body: string[] }>({
				query({ uuid, body }) {
					return {
						url: `offers/${uuid}/join/`,
						headers: { 'X-Csrftoken': getCookie('csrftoken') },
						method: 'POST',
						body: {
							sources_uuids: body,
						},
					};
				},
			}),
		}),
		overrideExisting: false,
	})
	.enhanceEndpoints({
		addTagTypes: [EApiTags.BRANDS_LIST, EApiTags.SINGLE_OFFER, EApiTags.OFFERS_LIST, EApiTags.DASHBOARD],
		endpoints: {
			getBrandsList: {
				providesTags: [EApiTags.BRANDS_LIST],
			},
			joinBrands: {
				invalidatesTags: [EApiTags.BRANDS_LIST, EApiTags.SINGLE_OFFER, EApiTags.OFFERS_LIST, EApiTags.DASHBOARD],
			},
			joinOffer: {
				invalidatesTags: [EApiTags.BRANDS_LIST, EApiTags.SINGLE_OFFER, EApiTags.OFFERS_LIST, EApiTags.DASHBOARD],
			},
		},
	});

export const { useGetBrandsListQuery, useJoinBrandsMutation, useJoinOfferMutation } = brandsApi;
